import { useIntl } from 'react-intl';
import { canvasService } from '../../../apiServices/CanvasService';
import { ConfirmModal } from '../../../components/Modal/ConfirmModal';
import { useUser } from '../../../context/User/useUser';

type DeleteProjectModalProps = {
  canvasId: string;
};

export const DeleteProjectModal = ({ canvasId }: DeleteProjectModalProps) => {
  const { fetchUser } = useUser();
  const intl = useIntl();

  const onDeleteProject = () =>
    canvasService.deleteCanvas(canvasId).then(({ message }) => {
      fetchUser();
      return message;
    });

  return (
    <ConfirmModal
      title={intl.formatMessage({ id: 'deleteProject.title' })}
      variant="danger"
      confirmLabel={intl.formatMessage({ id: 'deleteProject.yes' })}
      confirmingLabel={intl.formatMessage({ id: 'deleteProject.loading' })}
      cancelLabel={intl.formatMessage({ id: 'deleteProject.no' })}
      onConfirm={onDeleteProject}
    >
      <p>{intl.formatMessage({ id: 'deleteProject.confirm' })}</p>
    </ConfirmModal>
  );
};
